import React from "react";
import { TableRow } from "@mui/material";
import { Product } from "../../../../data/entities";
import CustomTable from "../../../../shared/components/CustomTable";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { formatInternationalNumber } from "../../../../utils/format";
import { ProductTableText } from "../../../ProductOrder/single/Styled";

const columns = ["Mã", "Sản phẩm", "Số lượng đơn", "Đã phân chuyến", "Đã xuất", "Trả lại", "Còn lại"]
    .map(text => ({ text, icon: <></> }));

const quantityText = (value?: number) => value == null ? "—" : formatInternationalNumber(value);

function ProductDeliverySummaryRow({ item }: { item: Product }) {
    return (
        <TableRow>
            <StyledTableCell>{item.product_code}</StyledTableCell>
            <StyledTableCell>{item.name}</StyledTableCell>
            <StyledTableCell>{quantityText(item.selectedQuantity)}</StyledTableCell>
            <StyledTableCell>{quantityText(item.deliverySentQuantity)}</StyledTableCell>
            <StyledTableCell>{quantityText(item.deliveryExportedQuantity)}</StyledTableCell>
            <StyledTableCell>{quantityText(item.deliveryReturnedQuantity)}</StyledTableCell>
            <StyledTableCell>{quantityText(item.deliveryRemainingQuantity)}</StyledTableCell>
        </TableRow>
    );
}

export function ProductDeliverySummary({ products }: { products: Product[] }) {
    return (
        <section aria-labelledby="product-delivery-summary-title" style={{ display: "flex", flexDirection: "column", gap: "12px", minWidth: 0 }}>
            <ProductTableText as="h3" id="product-delivery-summary-title" style={{ margin: 0 }}>
                Lũy kế theo sản phẩm
            </ProductTableText>
            {products.length > 0 ? (
                <CustomTable itemList={products} RowElement={ProductDeliverySummaryRow} TableColumns={columns} />
            ) : "Chưa có sản phẩm trong đơn hàng."}
        </section>
    );
}
